/* eslint-disable max-len */
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/* eslint-enable max-len */

export const parseEmailListString = (stringList: string): Array<string> =>
  stringList
    .trim()
    .replace(/ /g, ',')
    .split(',')
    .filter((value) => value.length > 0);

export const validateEmail = (email: string): boolean => emailRegex.test(email);

export const validateEmailList = (emailList: Array<string> = []): boolean =>
  emailList.every(validateEmail);
